<template>
    <div>
    <app-dialog width="60%" :isProfileDialog="true" :value="value" :title="tb(title)" :isPersistent="true" v-bind="$attrs" @input="onDialogInput">
        <template v-slot:content>
            <v-form ref="form" lazy-validation>
                <div class="px-3" id="wrap_content_profile">
                    <v-row class="my-0">
                        <v-col cols="6" class="pt-0 pb-0">
                            <v-text-field class="text-field-asterisk" v-model="currentProfile.name" :rules="[rules.required,rules.max]">
                                <template v-slot:label>
                                    <span>{{ $t('userDetails.name') }}&nbsp;</span>
                                    <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="my-0">
                        <v-col cols="12">
                            <v-row class="d-flex flex-column px-2 mx-1 my-0 wrap-content">
                                <v-col cols="12" md="12" sm="12" class="d-flex justify-start px-0 pt-0">
                                    <v-tabs centered id="myprovet-tabs" v-model="selectedTabIndex" class="pt-1 ml-n1" style="border-radius: 8px" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px" start show-arrows>
                                        <v-tabs-slider color="#154579"></v-tabs-slider>

                                        <v-tab class="myprovet-tab-item" v-for="item in tabItems" :key="item.tab">
                                            {{ tb(item.tab) }}
                                        </v-tab>
                                    </v-tabs>
                                </v-col>

                                <v-divider></v-divider>
                            <div class="client-tab product-excluded-tab" style="padding-top: 12px;" ref="detailsTab" v-if="selectedTabIndex === getSelectedTabIndex('PRODUTOS')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col class="pr-2" style="max-width: fit-content">
                                            <div>
                                                <div class="title-text dark-blue-color" style="max-width: min-content; white-space: nowrap">{{ $t('profileDialog.excludedProducts') }}</div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex align-center justify-space-between mx-0 mt-0">
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                                        <v-radio-group row
                                            v-model="direction"
                                            hide-details
                                        >
                                            <v-radio
                                            value="search"
                                            :label="tb('Procurar Produtos')"
                                            ></v-radio>
                                            <v-radio
                                            value="upload"
                                            :label="tb('Carregar ficheiro')"
                                            ></v-radio>
                                        </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0" v-if="direction=='search'">
                                            <v-col cols="8" >
                                                <multiselect
                                                    id="ajax"
                                                    autocomplete="none"
                                                    :placeholder="tb('Procurar produto para excluir')"
                                                    :multiple="true"
                                                    :searchable="true"
                                                    name="referencia"
                                                    track-by="code"
                                                    v-model="selectedRef"
                                                    :internal-search="false"
                                                    :clear-on-select="false"
                                                    :close-on-select="false"
                                                    :options-limit="300"
                                                    :max-height="220"
                                                    :show-no-results="true"
                                                    :hide-selected="false"
                                                    :show-labels="false"
                                                    :preserveSearch="true"
                                                    @search-change="remoteArticlesMethod"
                                                    :custom-label="customLabel"
                                                    :loading="loadingArticles"
                                                    :options="listArticles"
                                                    >
                                                    <template slot="singleLabel" slot-scope="props"
                                                        ><span class="option__desc"
                                                        ><span class="option__title">{{
                                                            props.option.name
                                                        }}</span></span
                                                        ></template
                                                    >
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc">
                                                        <span class="option__title">{{ props.option.name }} </span>
                                                        </div>
                                                    </template>
                                                    <span slot="noOptions"></span>
                                                    <span slot="noResult">{{ tb('Sem resultados.') }}</span>
                                                </multiselect>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-btn text :disabled="selectedRef!=null&&selectedRef!=''?false:true" :class="selectedRef!=null&&selectedRef!=''?'myprovet-btn-ok btn-add-excluded':'myprovet-btn-disabled btn-add-excluded'" @click="addRefToExcludedList"> {{ tb('Adicionar') }} </v-btn>
                                            </v-col>
                                        </v-col>
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0" v-else>
                                            <v-col cols="6"  class="mx-0 mt-0 pt-0">
                                                     <template>
                                                        <v-file-input  @change="setFile" class="pt-0" ref="inputFile"
                                                            show-size
                                                            accept=".xlsx"
                                                            :label="tb('Ficheiro com produtos')"
                                                        ></v-file-input>
                                                    </template>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-btn text :disabled="currentFile!=null&&currentFile!=''?false:true" :class="currentFile!=null&&currentFile!=''?'myprovet-btn-ok btn-add-excluded':'myprovet-btn-disabled btn-add-excluded'" @click="processFile"> {{ tb('Adicionar') }} </v-btn>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-btn text :class="'myprovet-btn-ok'" @click="exportData"> {{ tb('Exportar') }} </v-btn>
                                            </v-col>
                                            <!--<v-col cols="3" >
                                                <v-btn text v-if="currentFile!=null?true:false" class="myprovet-btn-ok btn-add-excluded" @click="processFile"> {{ tb('Submeter') }} </v-btn>
                                            </v-col> ficará apenas os produtos que estiverem no excel!-->
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex align-center justify-space-between mx-0 mt-0" v-if="currentFile!=null&&currentFile!='' && currentProfile.profile_excluded_products.length>0">
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                                            <v-alert
                                                prominent
                                                type="error"
                                                >
                                                <v-row align="center">
                                                    <v-col class="grow alert-exclused-product-file">
                                                      {{ $t('profileDialog.fileWarning') }}
                                                    </v-col>
                                                    <v-col class="shrink">
                                                    </v-col>
                                                </v-row>
                                                </v-alert>
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex align-center justify-space-between mx-0 mt-0">
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                                            <v-col cols="4" >
                                            <v-text-field
                                                        v-model="searchArticle"
                                                        append-icon="mdi-magnify"
                                                        :label="tb('Procurar na lista')"
                                                        single-line

                                                        hide-details
                                                    ></v-text-field>
                                            </v-col>
                                            <v-col cols="8">
                                            </v-col>
                                        </v-col>

                                    </v-row>

                                    <div class="px-3">
                                        <v-data-table id="delivery_table"

                                            ref="datatableProfilesDetails"
                                            class="elevation-1 mt-2 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                            fixed-header
                                            multi-sort
                                            :headers="tHeaders(refs_headers)"
                                            :header-props="headerProps"
                                            :hide-default-headers="isMobile"
                                            :items="currentProfile.profile_excluded_products"
                                            :footer-props="footerPropsCustoms"
                                            :search="searchArticle"
                                            :no-data-text="tb('Não existem produtos para mostrar.')"
                                            no-results-text="Não existem produtos para mostrar."
                                            :loading="isLoading"
                                            :loading-text="$t('table.loading')"
                                        >
                                            <template #item.name="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.name }}
                                                </div>
                                            </template>

                                            <template #item.created_by="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.created_by }}
                                                </div>
                                            </template>

                                            <template #item.created_at="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.created_at }}
                                                </div>
                                            </template>

                                            <template #[`item.actions`]="scope">
                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openRemove(scope.item)"> mdi-delete </v-icon>
                                                        </template>
                                                        <span>{{ tb('Remover produto') }}</span>
                                                    </v-tooltip>
                                                <!--div v-if="userStore.hasPermissionTo('Request client details page changes')" class="d-flex justify-end align-center">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openAddressChangeDialog(scope.item)"> mdi-square-edit-outline </v-icon>
                                                        </template>
                                                        <span>{{ tb('Pedido de alteração') }}</span>
                                                    </v-tooltip>
                                                </div>-->
                                            </template>
                                        </v-data-table>
                                    </div>
                            </div>
                            <div class="client-tab product-excluded-tab" ref="detailsTab" style="padding-top: 12px;" v-if="selectedTabIndex === getSelectedTabIndex('LABORATÓRIOS')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col class="pr-2" style="max-width: fit-content">
                                            <div>
                                                <div class="title-text dark-blue-color" style="max-width: min-content; white-space: nowrap">{{ $t('profileDialog.excludedLabs') }}</div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex align-center justify-space-between mx-0 mt-0">
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                                            <v-col cols="8" >
                                                <multiselect
                                                    id="ajax"
                                                    autocomplete="none"
                                                    :placeholder="tb('Procurar laboratório para excluir')"
                                                    :multiple="true"
                                                    :searchable="true"
                                                    track-by="laboratory_code"
                                                    name="laboratorio"
                                                    v-model="selectedLab"
                                                    :internal-search="false"
                                                    :clear-on-select="false"
                                                    :close-on-select="false"
                                                    :options-limit="300"
                                                    :max-height="220"
                                                    :show-no-results="true"
                                                    :hide-selected="false"
                                                    :show-labels="false"
                                                    :preserveSearch="true"
                                                    @search-change="remoteLabsMethod"
                                                    :custom-label="customLabel"
                                                    :loading="loadingArticles"
                                                    :options="listLabs"
                                                    >
                                                    <template slot="singleLabel" slot-scope="props"
                                                        ><span class="option__desc"
                                                        ><span class="option__title">{{
                                                            props.option.laboratory
                                                        }}</span></span
                                                        ></template
                                                    >
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc">
                                                        <span class="option__title">{{ props.option.laboratory }} </span>
                                                        </div>
                                                    </template>
                                                    <span slot="noOptions"></span>
                                                    <span slot="noResult">{{ tb('Sem resultados.') }}</span>
                                                </multiselect>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-btn text :disabled="selectedLab!=null&&selectedLab!=''?false:true" :class="selectedLab!=null&&selectedLab!=''?'myprovet-btn-ok btn-add-excluded':'myprovet-btn-disabled btn-add-excluded'" @click="addLabToExcludedList"> {{ tb('Adicionar') }} </v-btn>
                                            </v-col>
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex align-center justify-space-between mx-0 mt-0">
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                                            <v-col cols="4" >
                                            <v-text-field
                                                        v-model="searchLab"
                                                        append-icon="mdi-magnify"
                                                        :label="tb('Procurar na lista')"
                                                        single-line
                                                        hide-details
                                                    ></v-text-field>
                                            </v-col>
                                            <v-col cols="8">
                                            </v-col>
                                        </v-col>

                                    </v-row>

                                    <div class="px-3">
                                        <v-data-table id="delivery_table"

                                            ref="datatableProfilesDetails"
                                            class="elevation-1 mt-2 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                            fixed-header
                                            multi-sort
                                            :headers="tHeaders(labs_headers)"
                                            :header-props="headerProps"
                                            :hide-default-headers="isMobile"
                                            :items="currentProfile.profile_excluded_labs"
                                            :footer-props="footerPropsCustoms"
                                            :search="searchArticle"
                                            :no-data-text="tb('Não existem laboratários para mostrar.')"
                                            no-results-text="Não existem laboratários para mostrar."
                                            :loading="isMobile?isLoading:false"
                                            :loading-text="$t('table.loading')"
                                        >
                                            <template #item.name="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.name }}
                                                </div>
                                            </template>

                                            <template #[`item.actions`]="scope">
                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openRemove(scope.item)"> mdi-delete </v-icon>
                                                        </template>
                                                        <span>{{ tb('Remover Referência') }}</span>
                                                    </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </div>
                            </div>
                        </v-row>
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text outlined class="myprovet-btn-cancel" @click="onCloseDialog"> {{ tb('Cancelar') }} </v-btn>

            <v-btn text class="myprovet-btn-ok" @click="save"> {{ tb('Gravar') }} </v-btn>
        </template>
    </app-dialog>
    <app-dialog :value="isConfirmChangesDialogOpen" @input="isConfirmChangesDialogOpen = $event" :title="tb('Atenção!')" width="35vw">
            <template v-slot:content>
                <p class="dark-blue-color pt-4" style="font-size: 16px">{{ tb('Tem a certeza que deseja eliminar o registo da lista de exclusão?') }}</p>
            </template>
            <template v-slot:buttons>
                <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isConfirmChangesDialogOpen = false">{{ tb('Cancelar') }}</v-btn>
                <v-btn text class="myprovet-btn-ok px-8" @click="removeItemFromExcludedList">{{ tb('Confirmar') }}</v-btn>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { axios } from '@/Services/Backend';
import Multiselect from 'vue-multiselect'
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';
import { useAppStore } from '@/Stores/app';
import ResizeObserver from 'resize-observer-polyfill';
import readXlsxFile from 'read-excel-file'

export default {
    components: { Multiselect },
    data() {
        return {
            selectedTabIndex: 0,
            tabItems: [
                {tab: 'PRODUTOS' },
               { tab: 'LABORATÓRIOS' }
            ],
            direction:'search',
            isLoading:false,
            currentFile:null,
            searchResults:[],
            listArticles:[],
            loadingArticles:false,
            searchArticle:'',
            selectedRef:[],
            listLabs:[],
            searchLab:'',
            selectedLab:[],
            searchResultsLabs:[],
            datatableSize: 200,
            generalDataSize: 200,
            profile_excluded_products:[],
            profile_excluded_labs:[],
            default_excluded_product:{
              id:null,
              name:null,
              code:null,
              laboratory_code:null,
              laboratory_id:null,
              product_id:null
            },
            default_excluded_lab:{
              id:null,
              laboratory:null,
              laboratory_code:null,
              laboratory_id:null,
            },
            isConfirmChangesDialogOpen:false,
            currentItem:null,
            footerPropsCustoms:{
                'items-per-page-options':[10,20,50 /*,{ text: "Todos", value: -1 }*/],
                'items-per-page-text': i18n.t('table.itemsPerPage')
            },
            rowPageText: i18n.t('table.itemsPerPage'),
            refs_headers:[
                /*{
                    "text": "",
                    "align": "start-padded",
                    "sortable": "true",
                    "value": "image",
                    "width": "10%"
                },*/
                {
                    "text": "REFERÊNCIA",
                    "align": "start",
                    "sortable": true,
                    "value": "code",
                    "width": "10%"
                },
                {
                    "text": "NOME",
                    "align": "start",
                    "sortable": true,
                    "value": "name",
                    "width": "30%"
                },
                {
                    "text": "LABORATÓRIO",
                    "align": "start",
                    "sortable": true,
                    "value": "laboratory",
                    "width": "15%"
                },
                {
                    "text": "",
                    "align": "center",
                    "sortable": false,
                    "value": "actions",
                    "width": "10%"
                }
            ],
            labs_headers:[

                {
                    "text": "NOME",
                    "align": "start",
                    "sortable": true,
                    "value": "laboratory",
                    "width": "90%"
                },
                {
                    "text": "",
                    "align": "center",
                    "sortable": false,
                    "value": "actions",
                    "width": "10%"
                }
            ],
            ref_model:{name:""},
            default_profile: {
                id:null,
                name: null,
                client_number:null,
                profile_excluded_products:[],
                profile_excluded_labs:[],
            },
            currentProfile:null,
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                max: (value) => (value && value.length<=40) || i18n.t('profileDialog.maxName'),
            },
        };
    },
    computed: {
        ...mapStores(useBranchStore, useUserStore,useAppStore),
    headerProps(){
            return this.appStore.header_props
        }
    },
    created() {
        this.copyOriginalData();
        this.prepareResponsiveBehaviour();
    },
    props: {
        value: { default: false },
        originalProfile: Object,
        branchId: String,
        isMobile:{ default: false },
        title:{ default: null },
    },

    methods: {
        setFile(file){
            this.currentFile=file
        },
        /*onFileChange(event) {
            let xlsxfile = event//event.target.files ? event.target.files[0] : null;
            readXlsxFile(xlsxfile).then((rows) => {
                _.each(rows,(row)=>{
                    let clone=_.clone(this.default_excluded_product)
                    console.log("row:", rows)

                })
            })
        },*/
        processFile(){
            let xlsxfile =this.currentFile
            this.isLoading=true;
            readXlsxFile(xlsxfile).then((rows) => {
                this.currentProfile.profile_excluded_products=[]
                _.each(rows,(row,index)=>{
                    if(index>0){
                        if(_.size(row)>1){
                            let clone=_.clone(this.default_excluded_product)
                             clone.code=row[0]
                             clone.name=row[1]
                             this.currentProfile.profile_excluded_products.push(clone)
                        }
                    }
                })
               this.$nextTick(_=>{
                this.currentFile=null
                this.$refs.inputFile.reset();
                this.isLoading=false;
              })
            })
        },
        openRemove(item){
            this.isConfirmChangesDialogOpen=true,
            this.currentItem=_.clone(item)
        },
        removeItemFromExcludedList(){
            this.isConfirmChangesDialogOpen=false
            if(this.selectedTabIndex==0){
                let index = _.findIndex(this.currentProfile.profile_excluded_products,{code:this.currentItem.code})
                if(index!=-1){
                    this.currentProfile.profile_excluded_products.splice(index,1)
                    this.showSuccess(this.tb('O item selecionado foi removido com sucesso!'));
                    this.currentItem=null
                }
            }else{
                let index = _.findIndex(this.currentProfile.profile_excluded_labs,{laboratory_code:this.currentItem.laboratory_code})
                if(index!=-1){
                    this.currentProfile.profile_excluded_labs.splice(index,1)
                    this.showSuccess(this.tb('O item selecionado foi removido com sucesso!'));
                    this.currentItem=null
                }
            }
        },
        addRefToExcludedList(){

           _.each(this.selectedRef,(o)=>{
                let index= _.findIndex(this.currentProfile.profile_excluded_products,{code:o.code})
            if(index==-1){
                let clone=_.clone(this.default_excluded_product)
                _.assign(clone,o)
                this.currentProfile.profile_excluded_products.unshift(clone)
                this.selectedRef=[]
            }
           })

        },
        addLabToExcludedList(){

            _.each(this.selectedLab,(o)=>{
                let index= _.findIndex(this.currentProfile.profile_excluded_labs,{laboratory_code:o.laboratory_code})
                if(index==-1){
                    let clone=_.clone(this.default_excluded_lab)
                    _.assign(clone,o)
                    this.currentProfile.profile_excluded_labs.unshift(clone)
                    this.selectedLab=[]
                }
           })
        },
        addLabToExcludedListOLD(){
            let index= _.findIndex(this.currentProfile.profile_excluded_labs,{code:this.selectedLab.laboratory_code})
            if(index==-1){
                let clone=_.clone(this.default_excluded_lab)
                _.assign(clone,this.selectedLab)
                this.currentProfile.profile_excluded_labs.unshift(clone)
                this.selectedLab=null
            }else{
                this.showError(this.tb('A referência selecionada já existe na lista de exclusões. Por favor selecione outra.'));
            }
        },
        customLabel(value){
          if(value.name){
            return `${value.name}`
          }else if(value.laboratory){
            return `${value.laboratory}`
          }else
            return `${value}`
         },
        remoteArticlesMethod: _.debounce(function(query) {
            let self = this
            //if (query !== '' && query.length >= 2) {
            if (query !== '' && query.length > 0) {
                this.loadingArticles = true
                //this.isActive = true
                axios.post('/api/profiles/search-articles', { query_search: query, branch_id: this.branchStore.branch.client_number })
                //this.$store.dispatch('searchAllArticlesByDesignWNotes', query).then(data => {
                    .then(data => {
                    let result = data
                    self.loadingArticles = false
                    if (result.data.length > 0) {
                        self.searchResults = result.data
                        self.listArticles = result.data.map(item => {
                            if(_.find(self.currentProfile.profile_excluded_products,{code:item.code})){
                                item['$isDisabled']=true
                             return item
                            }
                            return item
                        })
                    } else {
                        self.listArticles = []
                    }
                })
            } else {
            this.listArticles = []
            }
        }, 500),
        remoteLabsMethod: _.debounce(function(query) {
            let self = this
            //if (query !== '' && query.length >= 2) {
            if (query !== '' && query.length > 0) {
                this.loadingArticles = true
                //this.isActive = true
                axios.post('/api/profiles/search-labs', { query_search: query, branch_id: this.branchStore.branch.client_number })
                //this.$store.dispatch('searchAllArticlesByDesignWNotes', query).then(data => {
                    .then(data => {
                    let result = data
                    self.loadingArticles = false
                    if (result.data.length > 0) {
                        self.searchResultsLabs = result.data
                        self.listLabs = result.data.map(item => {
                            if(_.find(self.currentProfile.profile_excluded_labs,{laboratory_code:item.laboratory_code})){
                                item['$isDisabled']=true
                             return item
                            }
                            return item
                        })
                    } else {
                        self.listLabs= []
                    }
                })
            } else {
            this.listLabs = []
            }
        }, 500),
        prepareResponsiveBehaviour() {
            // Table and General Data responsivity
            const makeResponsive = () => {
                this.$nextTick(() => {
                    this.computeDatatableSize();
                });
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);

            window.addEventListener('resize', makeResponsive);

            // Scroll arrow
            this.$nextTick(() => {
                this.resizeObserver.observe(this.$refs.detailsTab);
            });
        },
        getSelectedTabIndex(tab) {
            if (this.tabItems.length === 0) return 0;

            return this.tabItems.findIndex((obj) => {
                return obj.tab === tab;
            });
        },
        computeDatatableSize() {
            this.datatableSize = window.innerHeight - 605;
            this.generalDataSize = this.editingGeneralData ? window.innerHeight - 605 : window.innerHeight - 600;
        },
        copyOriginalData() {
            let clone = _.cloneDeep(this.originalProfile)
            this.currentProfile= _.clone(this.default_profile)
            this.currentProfile.id =clone.id;
            this.currentProfile.name =clone.name;
            this.currentProfile.profile_excluded_products = clone.profile_excluded_products
            this.currentProfile.profile_excluded_labs = clone.profile_excluded_labs
            let numb=_.split(clone.client_number,'.')
            this.currentProfile.client_number=_.size(numb)>1?numb[0]:clone.client_number;
        },
        exportData() {

            const axiosSettings = {

                params: {
                    branch_id:this.branchStore.branch.client_number+'.0',
                },
            };
            axios({
            url:'/api/profiles/profile-products/export',
            method: 'POST',
            data: axiosSettings.params,
            responseType: 'blob'
            }).then((response)=> {

                var results = response.data;
                let blob = new Blob([results], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" //+ //file.extension
                });
                var url = window.URL.createObjectURL(blob)
                let link = document.createElement('a')
                link.href = url
                link.download = 'lista_produtos.xlsx';
                link.click();
                window?.EventBus?.$emit('export-finished');

            })
            .catch(()=> {
                window?.EventBus?.$emit('export-failed');
            })

        },

        save() {
            if (!this.$refs.form.validate()) return;

            let endpoint=null
            if(this.currentProfile.id){
                endpoint = axios.put('/api/profiles/profile/'+this.currentProfile.id,this.currentProfile);
            }else{
                endpoint = axios.post('/api/profiles/profile',this.currentProfile);
            }
            endpoint.then((data) => {
                    this.showSuccess(this.tb('O perfil foi gravado com sucesso!'));
                    this.$emit('on-success', true);
                    window.EventBus.$emit('update:profiles-list', true)
            }).catch((data) => {
                    this.showError(this.tb('O nome do perfil já está a ser utilizado. Por favor utilize outro.'));
                    this.loading = false;
            });
        },

        onDialogInput(event) {
            if (!event) {
                this.$emit('on-cancel', false);
            }
        },

        onCloseDialog() {
            this.$emit('on-cancel', false);
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .v-application ol, .v-application ul.multiselect__content{
        padding-left: 0;
    }
    .multiselect, .multiselect__input, .multiselect__single{
        font-size: 0.8rem !important;
    }
    .multiselect__tags{
      border-radius: 25px;
    }
    .multiselect .multiselect__select:before{
     top: 55%;
    }
    .btn-add-excluded.v-btn--disabled{
         cursor:not-allowed;
    }
</style>
